export default {
    foreignTrade: {
        Description: {
            title: 'Foreign trade services',
            module1: {
                title: 'Professional Foreign Trade Services',
                btn: 'View Details',
                box1: {
                    title: 'Trade Policy & Resource Services',
                    text: 'Provides global trade policy analysis, market access guidance, and resource matching to ensure compliance and facilitate international expansion. Comprehensive services covering anti-monopoly, IP protection, and trade dispute resolution to empower risk management and stable global operations.',
                },
                box2: {
                    title: 'Logistics & Warehousing',
                    text: 'End-to-end global shipping, warehouse management and customs clearance solutions for efficient international supply chain operations.',
                },
                box3: {
                    title: 'Translation & Localization',
                    text: 'Multilingual translation, document localization and cultural adaptation services to ensure accurate communication in global markets.',
                },
                box4: {
                    title: 'Risk Management',
                    text: 'Comprehensive risk assessment and alerts for currency, credit and logistics to safeguard international transactions.',
                },
            },
            module2: {
                title: 'Global Trade Connections, Smart Commerce Solutions',
                text: 'Our integrated platform connects businesses with premium global trade services, enabling efficient customs clearance, optimized supply chains, and risk mitigation for seamless China-global partnerships.',
                box1: {
                    title: 'Foreign Exchange Risk Management',
                    text: 'Currency analysis and hedging strategies using financial instruments to stabilize profits and ensure financial security.',
                },
                box2: {
                    title: 'Tax Refund Optimization',
                    text: 'Precise interpretation of global tax rebate policies and streamlined filing processes to accelerate fund recovery.',
                },
                box3: {
                    title: 'Global Market Intelligence',
                    text: 'Real-time industry trends and competitor analysis with data-driven insights for market advantage.',
                },
                box4: {
                    title: 'Supply Chain Consulting',
                    text: 'End-to-end optimization of supply chain efficiency and cost structures to build agile, competitive operations.',
                },
                box5: {
                    title: 'Cross-border E-commerce Solutions',
                    text: 'Full-spectrum support covering store setup, payments, warehousing and marketing for rapid global expansion.',
                },
                box6: {
                    title: 'Global Brand Strategy',
                    text: 'Customized overseas branding and promotion strategies to build international recognition and influence.',
                },
            },
        }
    }
}